import axios from "axios";

const state = {
    referenceId:'',
    customerName:'',
    accessToken:'',
    dialog: false,
    meterToken:'',
    units:''
};

const getters = {
    getElectDetail(state) {
        let electDetail ={
            referenceId: state.referenceId,
            customerName:state.customerName,
            accessToken: state.accessToken ,
            dialog: state.dialog,
            meterToken: state.meterToken,
            units: state.units,
        }
        return electDetail;
      }
};

const mutations = {
    setCustomerName(state, payload) {
        state.customerName = payload;
      },
    setAccessToken(state, payload) {
        state.accessToken = payload;
      },
    setReferenceId(state, payload) {
        state.referenceId = payload;
      },
    setDialog(state, payload) {
        state.dialog = payload;
      },
    setmeterToken(state, payload) {
        state.meterToken = payload;
      },
    setunits(state, payload) {
        state.units = payload;
      }
};

const actions = { 

    buyElectricity({commit}, payload){
        commit("setLoading", true);
        commit("setSnackbar", false);
        axios
          .post(
            `https://backoffice.teller.ng/TellerAppManager/api/ElectricityValidationRequest?meterNumber=${payload.meterNumber}&disco=${payload.disco}`
          )
          .then(res => {
            if (res.data.status == 0) {
                commit("setCustomerName",res.data.customerName);
                commit("setAccessToken",res.data.accessToken);
                commit("setReferenceId",res.data.referenceId);
                commit("setDialog",true);
                console.log(res.data)
                commit("setSnackbar", true);
                commit("setServerMessage", "OK")
            }
            else{
                commit("setSnackbar", true);
                commit("setServerMessage", res.data.message)
              }
          })
          .catch(err => {
            console.log(err, 'err')
            if (err.code === 'ECONNABORTED'){
              commit("setSnackbar", true);
              commit("setServerMessage",  "Server Timeout" );
              return
            }
            commit("setServerMessage",  err.message );
          })
          .finally(()=>{
            commit("setLoading", false);
          });
      },

      ConfirmBuyElectricity({commit}, payload){
        let customerNumber = payload.customerNumber;
        if (customerNumber.split("")[0] != "+") {
          while (customerNumber.charAt(0) === "0") {
            customerNumber = `+234${customerNumber.substr(1)}`;
          }
        }
        commit("setLoading", true);
        commit("setSnackbar", false);
        commit("setDialog",false);
        axios
        .post(
          `https://backoffice.teller.ng/TellerAppManager/api/ElectricityVendRequest?customerID=${payload.customerID}&pin=${payload.pin}&meterNumber=${payload.meterNumber}&disco=${payload.disco}&accessToken=${payload.accessToken}&referenceId=${payload.referenceId}&amountInCents=${payload.amount * 100}&customerPhoneNumber=${customerNumber}&imei='WEBSITE'&customerEmail=${payload.email}&location='WEBSITE'`
        )
        .then(res => {
          if (res.data.status == 0) {
            console.log(res.data)
            commit("setmeterToken", res.data.meterToken);
            commit("setunits", res.data.units);
            commit("setSnackbar", true);
            commit("setServerMessage", "Successful")
            commit("setBalance",  res.data.updatedMainBalance );
            commit("setCommissionBalance",  res.data.updatedCommissionBalance );
            commit("setDialog",true);
            commit("SetRouteName",  true );
            payload.route.push({name: "Successful"})
          }else{
            console.log(res.data)
            commit("setDialog",true);
            commit("setSnackbar", true);
            commit("setServerMessage", res.data.message)
          }
        })
        .catch(err => {
            console.log(err, 'err')
            if (err.code === 'ECONNABORTED'){
              commit("setSnackbar", true);
              commit("setServerMessage",  "Server Timeout" );
              return
            }
            commit("setServerMessage",  err.message );
          })
          .finally(()=>{
            commit("setLoading", false);
          });
      }

};

export default {
  state,
  mutations,
  getters,
  actions
};
